/* VIVA63 feature band — lazy autoplay/pause for chapter videos.
   (Copy follows the scroll via CSS position:sticky inside each chapter row.) */
(function () {
  'use strict';

  function setupVideos(root) {
    var videos = root.querySelectorAll('[data-viva-band-video]');
    if (!videos.length || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            if (v.dataset.src && !v.getAttribute('src')) {
              v.setAttribute('src', v.dataset.src);
              v.load();
            }
            var p = v.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      },
      { rootMargin: '10% 0px', threshold: 0.2 }
    );
    videos.forEach(function (v) {
      v.muted = true;
      io.observe(v);
    });
  }

  function init(root) {
    if (root.dataset.vivaBandReady) return;
    root.dataset.vivaBandReady = '1';
    setupVideos(root);
  }

  function boot() {
    document.querySelectorAll('[data-viva-band]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
